import CityPageTemplate from "../city-template/CityPageTemplate";
import { bangorConfig } from "./data";

export default function BangorPage() {
  return <CityPageTemplate config={bangorConfig} />;
}